module.exports = __webpack_public_path__ + "static/media/learn.c1358606.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/categories/learn.png
// module id = 493
// module chunks = 0